<template>
  <div
    class="screen-resource"
    :class="{'full-width': resource.resourceTypeName == 'video' || resource.resourceTypeName == 'link' || resource.resourceTypeName == 'document' || resource.resourceTypeName == 'subjectResource'}"
  >
    <!-- 图片 -->
    <div v-if="resource.resourceTypeName == 'image'">
      <UImageAttach
        :uFileId="'resource-' + resource.id"
        :uFilePath="resource.location"
        :uFileName="resource.title"
        :uFileSize="resource.contentSize"
      ></UImageAttach>
    </div>
    <!-- 视频 -->
    <div v-if="resource.resourceTypeName == 'video'">
      <div class="res-video">
        <UVideoAttach
          ref="resVideo"
          :uFilePath="resource.location"
          :uFileName="resource.title"
          :uFileSize="resource.contentSize"
        ></UVideoAttach>
      </div>
    </div>
    <!-- 音频 -->
    <div v-if="resource.resourceTypeName == 'audio'">
      <div class="res-audio">
        <UAudioAttach
          uName="audio-attach"
          ref="resAudio"
          :uFilePath="resource.location"
          :uFileName="resource.title"
          :uFileSize="resource.contentSize"
        ></UAudioAttach>
      </div>
    </div>
    <!-- 文档 -->
    <div v-if="resource.resourceTypeName == 'document'">
      <UDocAttach
        class="res-document"
        :uFilePath="resource.location"
        :uFileName="resource.title"
        :uFileSize="resource.contentSize"
      ></UDocAttach>
    </div>
    <!-- 图文 -->
    <div v-if="resource.resourceTypeName == 'richtext'">
      <div class="res-richtext" v-html="resource.description"></div>
    </div>
    <!-- 网页 -->
    <div v-if="resource.resourceTypeName == 'link'">
      <iframe class="res-link" :src="resource.location"></iframe>
    </div>
    <!-- 其他 -->
    <div v-if="resource.resourceTypeName == 'rar' || resource.resourceTypeName == 'other'">
      <div class="res-other">{{ $t("resource.notSupport") }}</div>
    </div>
    <!-- 引用来自学科资源库的资源结构样式单独处理 -->
    <div v-if="resource.resourceTypeName == 'subjectResource'">
      <iframe class="res-link" :src="resource.subjectResourceLocation"></iframe>
    </div>
  </div>
</template>

<script>
import EventHandler from "../../common/js/EventHandler";
import UAudioAttach from "../../common/components/uAttach/uAudioAttach.vue";
import UVideoAttach from "../../common/components/uAttach/uVideoAttach.vue";
import UImageAttach from "../../common/components/uAttach/uImageAttach.vue";
import UDocAttach from "../../common/components/uAttach/uDocAttach.vue";
export default {
  name: "resource",
  data() {
    return {
      resource: {}
    };
  },
  components: {
    UAudioAttach,
    UVideoAttach,
    UImageAttach,
    UDocAttach
  },
  methods: {
    initPage() {
      let self = this;
      self.activityId = self.common.getCookie("activityId");
      self.Authorization = self.common.getCookie("Authorization");
      self.getDetail();
    },
    getDetail() {
      let self = this;
      self.$http
        .get(self.baseURL + "/course/content/" + self.activityId, {
          headers: {
            Authorization: self.Authorization
          }
        })
        .then(res => {
          let data = res.data;
          self.$emit("pushDetial", data);
          if (data.type == 2) {
            data.location =
              data.location.indexOf("http") != -1
                ? data.location
                : "https://" + data.location;
          } else {
            data.location =
              data.location && self.common.buildResourcePath(data.location);
          }
          if (!data.location && data.localType == 1) {
            data.resourceTypeName = "subjectResource";
            data.subjectResourceLocation =
              "https://rm.ulearning.cn/#/resourceDetail/" + data.contentId;
            let localPath = location.hostname;
            if (localPath.indexOf("tongshike.cn") != -1) {
              data.subjectResourceLocation =
                "http://rsgl.tongshike.cn/#/resourceDetail/" + data.contentId;
            }
            if (localPath.indexOf(".ulearning.") != -1) {
              var i18nHost = localPath.substring(localPath.indexOf("."));

              data.subjectResourceLocation =
                "http://rsgl" +
                i18nHost +
                "/#/resourceDetail/" +
                data.contentId;
            }
          } else {
            data.resourceTypeName =
              data.type == 2 ? "link" : self.getFileType(data.mimeType);
          }
          self.resource = data;
        });
    },
    getFileType(ext) {
      var mime_types = [
        {
          title: "document",
          extensions: "doc,docx,xls,xlsx,ppt,pptx,pdf,txt"
        },
        {
          title: "image",
          extensions: "png,jpg,gif,jpeg,bmp"
        },
        {
          title: "video",
          extensions: "flv,mp4,avi,wmv,rm,rmvb,mpeg,mov,mpg"
        },
        {
          title: "audio",
          extensions: "mp3,wav,wma"
        },
        {
          title: "rar",
          extensions: "rar,zip"
        }
      ];
      if (ext == "" || ext == null) {
        return "richtext";
      } else {
        ext = ext.toLowerCase();
      }
      for (var i = 0; i < mime_types.length; i++) {
        var extArr = mime_types[i].extensions.split(",");
        for (var j = 0; j < extArr.length; j++) {
          if (extArr[j] == ext) {
            return mime_types[i].title;
          }
        }
      }
      return "other";
    },
    handleMedia: function(param) {
      if (this.resource.resourceTypeName == "video") {
        this.$refs.resVideo.handleMedia(param);
      } else if (this.resource.resourceTypeName == "audio") {
        this.$refs.resAudio.handleMedia(param);
      }
    }
  },
  mounted: function() {},
  created() {
    EventHandler.bindEvent("handleMedia", this.handleMedia);
    this.initPage();
  },
  watch: {
    $route: "initPage"
  },
  beforeDestroy() {}
};
</script>

<style lang="scss">
.screen-resource {
  width: 930px;
  margin: 0 auto;
  height: calc(100vh - 96px);
  overflow: auto;
  &.full-width {
    width: 100%;
  }
  img {
    max-width: 100%;
  }
  .res-video {
    width: 100%;
    height: calc(100vh - 96px);
    margin: 0 auto;
  }
  .res-audio {
    width: 400px;
    max-width: 100%;
    margin: 0 auto;
    padding: 200px 20px;
  }
  .res-document {
    width: 100%;
    height: calc(100vh - 96px);
    overflow: auto;
    background-color: #fff;
    border: none;
  }
  .res-richtext {
    min-height: calc(100vh - 96px);
    background-color: #fff;
    padding: 20px;
    font-size: 24px;
    img {
      max-width: 100%;
    }
    p {
      font-size: 24px;
    }
  }
  .res-link {
    width: 100%;
    height: calc(100vh - 96px);
    overflow: auto;
    background-color: #fff;
    border: none;
  }
  .res-other {
    padding: 150px 10px;
    text-align: center;
    font-size: 24px;
    color: #fff;
  }
}
@media all and (max-width: 1024px) {
  .screen-resource {
    width: 96%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/resource/resource.vue